import { render, staticRenderFns } from "./banqueo.vue?vue&type=template&id=ab5f8fe6&"
import script from "./banqueo.vue?vue&type=script&lang=js&"
export * from "./banqueo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports